import { useMemo, useState } from 'react'

export function usePaginate(items, orderType) {
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const endOffset = itemOffset + itemsPerPage

  const filteredItems = useMemo(() => {
    setPageCount(Math.ceil(items.length / itemsPerPage))

    return items.slice(itemOffset, endOffset)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    endOffset,
    itemOffset,
    items,
    itemsPerPage,
    orderType.type,
    orderType.field,
  ])

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length

    setItemOffset(newOffset)
  }

  return {
    pageCount,
    handlePageClick,
    filteredItems,
    itemsPerPage,
    setItemsPerPage,
  }
}
